import { ManualSmsScheduledService } from '@weave/schema-gen-ts/dist/schemas/messaging/scheduled/manual-sms/v1/manualsms.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaManualSmsScheduledV1Service = bindHTTP(ManualSmsScheduledService);
export const serviceName = 'manual-sms-scheduled-v1' as const;
